import axios from "axios";

export default {
    getAllOld(currentPage = 0, pageSize = 10, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/eventsOld?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    reschedule(id, data) {
        return axios({
            method: "put",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/reschedule",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createEvent(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/schedule/event",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateEvent(data) {
        return axios({
            method: "put",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/schedule/event",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllVisitType() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/schedule/visitTypes",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllVisitTypeActive() {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE + "auth/schedule/visitTypes/active",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllWorkScheduleEvents() {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE + "auth/schedule/events/workschedule",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getEventsPayExcel(data) {
        return axios({
            method: "post",
            data: data,
            responseType: "blob",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/schedule/events/pay/excel",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllEventsAndDeletePerformanceExcel(data) {
        return axios({
            method: "post",
            data: data,
            responseType: "blob",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/events/delete/performance/excel",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllEventsAndDeletePerformanceGalateaExcel(data) {
        return axios({
            method: "post",
            data: data,
            responseType: "blob",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/events/delete/performance/galatea/excel",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllEventsAndDeletePerformance(currentPage = 0, pageSize = 10, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/events/delete/performance?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllEventsAndDelete() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/schedule/events/delete",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllEvents() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/schedule/events",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllEventsVuetify() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/schedule/events/vuetify",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllEventsVuetifyFilter(currentPage = 0, pageSize = 10, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/events/vuetify?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllEventsByDate(data) {
        return axios({
            method: "post",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/schedule/events/date",
            data: data,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getEvent(id) {
        const isV3Professional = localStorage.getItem("v3") === "true" && localStorage.getItem("role") === "PROFESSIONAL";
        const url = isV3Professional
            ? process.env.VUE_APP_BASE_URL_CORE + "auth/v3/event/" + id
            : process.env.VUE_APP_BASE_URL_CORE + "auth/schedule/event/" + id;
        return axios({
            method: "get",
            url: url,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    deleteEvent(id, sendEmail) {
        return axios({
            method: "delete",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/schedule/event/" + id +"/" +sendEmail,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getNextEvents(number) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/nexts/" +
                number,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    setEventFinishAt(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/finish",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    setEventInitAt(id) {
        const isV3Professional = localStorage.getItem("v3") === "true" && localStorage.getItem("role") === "PROFESSIONAL";
        const url = isV3Professional
            ? process.env.VUE_APP_BASE_URL_CORE + "auth/v3/event/" + id + "/init"
            : process.env.VUE_APP_BASE_URL_CORE + "auth/schedule/event/" + id + "/init";
        return axios({
            method: "get",
            url: url,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    setEventExtraTimeEvent(id, extraTime) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/extra/" + extraTime,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    //Payments
    payStripe(id, patientId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/patient/" +
                patientId +
                "/pay/stripe",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payPaypal(id, patientId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/patient/" +
                patientId +
                "/pay/paypal",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payCash(id, patientId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/patient/" +
                patientId +
                "/pay/cash",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    unpay(id, patientId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/patient/" +
                patientId +
                "/unpay",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payStripeBeforeEvent(id, patientId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/patient/" +
                patientId +
                "/pay/stripe/before",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payPaypalBeforeEvent(id, patientId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/patient/" +
                patientId +
                "/pay/paypal/before",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payCashBeforeEvent(id, patientId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/patient/" +
                patientId +
                "/pay/cash/before",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    paySuccess(patientId, id, option, tokenback, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/patient/" +
                patientId +
                "/pay/success/" +
                option +
                "/" +
                tokenback,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payCancel(patientId, id, mode, token, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/patient/" +
                patientId +
                "/pay/cancel/" +
                mode +
                "/" +
                token,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    generateInvoiceByPatient(id, patientId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/patient/" +
                patientId +
                "/invoice",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    generateInvoice(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/invoice",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    paidOffline(id, mode, patientId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/patient/" +
                patientId +
                "/paid/offline/" +
                mode,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    putExtraTime(id, time) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                id +
                "/extra/" +
                time,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllEventPlataform(currentPage = 0, pageSize = 10, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/events/pay?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllPlataformPayPending(currentPage = 0, pageSize = 10) {
        return axios({
            method: "post",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/events/pay/pending?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    putPaymentOutPlataformAndPay(eventId, patientId, paymentOutPlataformId) {
        return axios({
            method: "put",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/schedule/event/" +
                eventId +
                "/patient/" +
                patientId +
                "/paymentOutPlataform/" +
                paymentOutPlataformId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
